import tableStoreModule from '@/store/modules/table_v3/index.js'
import _ from "lodash";
import Vue from "vue";

export default {
    
    data() {
        return {
            tableStoreNamespaceSufix: 'table_v3',
            tableStoreNamespacePrefix: '',
        }
    },

    computed: {

        tableStoreNamespace: function(){
            return this.tableStoreNamespacePrefix + this.tableStoreNamespaceSufix;
        },  
        
        columns: function(){ 
            return this.tableStoreGetter('orderedColumns'); 
        },

        fixedColumns: function(){
            return this.tableStoreGetter('fixedColumns');
        },

        sortedColumns: function(){
            return this.tableStoreGetter('sortedColumns');
        },

        headerRows: function(){
            return this.tableStoreGetter('headerRows');
        },

        bodyRows: function(){
            return this.tableStoreGetter('bodyRows');
        },

        footerRows: function(){            
            return this.tableStoreGetter('footerRows');
        }
    },

    methods : {

        getColumnColspan(column) {
            return _.get(column, 'meta.attributes.colspan', 1);
        },

        getColumnRowspan(column) {
            return _.get(column, 'meta.attributes.rowspan', 1);
        },

        getColumnSort(columnId) {
            let direction = 'none';
            let result = _.some(this.sortedColumns, sorting => _.some(sorting, (sortingDirection, sortingColumnId) => { 
                if( columnId === sortingColumnId ) {
                    direction = sortingDirection; 
                    return true;
                }
                return false;
            }));
            return direction;
        },

        isFixedColumn(columnId) {
            return this.fixedColumns.indexOf(columnId) !== -1;
        },

        isFixedColumnLast(columnId) {
            let index = this.fixedColumns.indexOf(columnId);
            return ( index > -1 ) ? this.fixedColumns.length === (index + 1) : false;
        },

        initTableStore() {
            if( ! (this.tableStoreNamespace + '/' in this.$store._modulesNamespaceMap) ) {
                this.$store.registerModule(this.tableStoreNamespace, tableStoreModule);            
            }
        },

        addTableStoreNamespace(name) {
            return this.tableStoreNamespace + '/' + name;
        },

        setTableStoreNamespacePrefix(prefix) {
            this.tableStoreNamespacePrefix = prefix;
        },

        tableStoreGetter(getter) {
            getter = this.addTableStoreNamespace(getter);
            return this.$store.getters[getter];
        },

        tableStoreDispatch(action, ...args) {
            action = this.addTableStoreNamespace(action);            
            if( this.$store._actions[action] ) {
                return this.$store.dispatch(action, ...args);
            }
        },

        fireMetaEvent(item, eventName, ...args) {
            let meta  = this.getMeta(item);
            if( meta && meta.events ) {
                let events = meta.events;
                if( events.hasOwnProperty(eventName) ) {
                    events[eventName].apply(item, args);
                }
            }
        },

        getMetaAttributesClasses(item) {
            let attr = this.getMetaAttributes(item);
            if( attr && attr.classes && attr.classes.length > 0 ) {
                return attr.classes;
            }
            return [];
        },

        getMetaAttributesValue(item, name, defaultValue = undefined) {
            return _.get(item, 'meta.attributes.' + name, defaultValue);
        },

        getMetaValue(item, path, defaultValue = undefined) {
            return _.get(item, 'meta.' + path, defaultValue);
        },

        getMetaAttributes(item) {
            let meta = this.getMeta(item);
            if( meta && meta.attributes ) {
                return meta.attributes;
            }
            return null;
        },

        getMeta(item) {
            if( item && item.meta ) {
                return item.meta;
            }
            return null;
        },


        importComponent(item) {

            let component = _.get(item, 'meta.component');
            
            var components = this.$options.components;
            let loaded = [];
            for (let key in components) {                
                loaded.push(key);
            }

            if( loaded.indexOf(component) === -1  ) {
                switch(component) {
                    case 'TableHeaderDateRange': 
                        Vue.component(
                            component,
                            () => import('@/components/common/table_v3/components/TableHeaderDateRange.vue')
                        );
                        break;

                    case 'RowLoading': 
                        Vue.component(
                            component,
                            () => import('@/components/common/table_v3/components/RowLoading.vue')
                        );
                        break;

                    case 'AdGroupReportAdgroup': 
                        Vue.component(
                            component,
                            () => import('@/components/common/table_v3/components/AdGroupReportAdgroup.vue')
                        );
                        break;

                    case 'AdGroupReportRevenue': 
                        Vue.component(
                            component,
                            () => import('@/components/common/table_v3/components/AdGroupReportRevenue.vue')
                        );
                        break;
                        
                }
            }

            return component;
        },

        isComponent(item) {
            return _.get(item, 'meta.component') !== undefined;       
        },       
    }

}


// WEBPACK FOOTER //
// ./src/components/common/table_v3/mixin/internal.mixin.js